import { withPrefix } from "gatsby"
import React, {useState} from "react"

const CustomTimePicker = ({appointmentDetails,setAppointmentDetails,errHour,errMinutes,setErrHour,setErrMinutes}) => {
    const initialTimeinArray = appointmentDetails.time.split(":")
    const [hours, setHours] = useState(initialTimeinArray[0])
    const [minutes, setMinutes] = useState(initialTimeinArray[1].split(" ")[0])
    const [ampm, setAMPM] = useState(initialTimeinArray[1].split(" ")[1])

    const allowedAMValues = {
      min: 7,
      max: 11,
    }

    const allowedPMValues = {
      min: 1,
      max: 8,
    }

    const handleHours = (value, ampmTemp = "") => {
      if (value.includes(".")) {
        return
      }
      const intValue = parseInt(value)
      if (value === "0") {
        return
      }
      if (((intValue > -1) && (intValue < 13)) || value === "") {
        setHours(value)
        setAppointmentDetails(prev => {
          return {
            ...prev,
            time : `${value}:${minutes} ${ampm}`
          }
        })
      } else {
        return
      }
      if (ampmTemp) {
        if (ampmTemp === "AM") {
          if (
            !(intValue >= allowedAMValues.min && intValue <= allowedAMValues.max)
          ) {
            setErrHour(true)
          } else {
            setErrHour(false)
          }
        } else {
          if (
            !(intValue >= allowedPMValues.min && intValue <= allowedPMValues.max || (intValue === 12))
          ) {
            setErrHour(true)
          } else {
            setErrHour(false)
          }
        }
      } else {
        if (ampm === "AM") {
          if (
            !(intValue >= allowedAMValues.min && intValue <= allowedAMValues.max)
          ) {
            setErrHour(true)
          } else {
            setErrHour(false)
          }
        } else {
          if (
            !((intValue >= allowedPMValues.min && intValue <= allowedPMValues.max) || (intValue === 12))
          ) {
            setErrHour(true)
          } else {
            setErrHour(false)
          }
        }
      }
      handleMinutes(minutes,ampm,value)
    }
  
    const handleMinutes = (value, ampmTemp = "",hrstemp = '') => {
      if (!hrstemp){
        hrstemp = hours
      }
      if (value.includes(".")) {
        return
      }
      if (value > -1 && value < 60) {
        setMinutes(value)
        setAppointmentDetails(prev => {
          return {
            ...prev,
            time : `${hrstemp}:${value} ${ampm}`
          }
        })
      } else {
        return
      }
      if (ampmTemp) {
        if (ampmTemp === "PM") {
          if (
            (parseInt(hrstemp) === allowedPMValues.max &&
            !["00", "0"].includes(value)) || (value === "")
          ) {
            setErrMinutes(true)
          } else {
            setErrMinutes(false)
          }
        }else if (ampmTemp === "AM"){
          if (value === ""){
            setErrMinutes(true)
          }else{
            setErrMinutes(false)
          }
        } else {
          setErrMinutes(false)
        }
      } else {
        if (ampm === "PM") {
          if (
            (parseInt(hrstemp) === allowedPMValues.max &&
            !["00", "0"].includes(value)) || (value === "")
          ) {
            setErrMinutes(true)
          } else {
            setErrMinutes(false)
          }
        } else if (ampm === "AM"){
          if (value === ""){
            setErrMinutes(true)
          }else{
            setErrMinutes(false)
          }
        }else {
          setErrMinutes(false)
        }
      }
    }

    const handleAMPM = value => {
      setAMPM(value)
      handleHours(hours, value)
      handleMinutes(minutes, value)
      setAppointmentDetails(prev => {
        return {
          ...prev,
          time : `${hours}:${minutes} ${value}`
        }
      })
    }

    return (
      <>
        <div
          className="custom-time-picker"
          style={errMinutes || errHour ? { border: "1px solid red" } : {}}
        >
          <div className="custom-time-picker-box">
            <input
              type="text"
              value={hours}
              onChange={e => handleHours(e.target.value)}
              placeholder="HH"
              maxLength={2}
            />
          </div>
          <span>:</span>
          <div className="custom-time-picker-box">
            <input
              type="text"
              value={minutes}
              onChange={e => handleMinutes(e.target.value)}
              placeholder="MM"
              maxLength={2}
            />
          </div>
          <div className="custom-time-picker-box">
            <select
              tabIndex={0}
              value={ampm}
              onChange={e => handleAMPM(e.target.value)}
            >
              <option value="AM">AM</option>
              <option value="PM">PM</option>
            </select>
          </div>
          <img
            src={withPrefix("images/clock.png")}
            style={{
              height: "18px",
              width: "18px",
              position: "absolute",
              right: "6px",
              top: "6px",
            }}
            alt=""
          />
        </div>
      </>
    )
  }

  export default CustomTimePicker;